import React from "react";
import "./ChooseCluster.css";

const ChooseCluster = () => {
  return (
    <div className="choose-cluster-container">
      <section
        className="choose-cluster-banner"
        style={{
          backgroundImage: `linear-gradient(90deg, rgba(0,0,0,.75) 0%, rgba(0,0,0,.15) 65%, rgba(0,0,0,.15) 100%), url(${
            process.env.PUBLIC_URL + "/Images/ChooseCluster/cluster-hero.jpg"
          })`,
        }}
      >
        <div className="choose-cluster-banner__inner">
          <h1 className="choose-cluster-banner__title">How do I choose a cluster?</h1>
          <p className="choose-cluster-banner__subtitle">Mapped to Your Role and Core Skills</p>
        </div>
      </section>
      <div className="choose-cluster-wrapper">
        <div className="choose-cluster-content">
          <img
            className="choose-cluster-image"
            src={
              process.env.PUBLIC_URL + "/Images/ChooseCluster/people-collab.jpg"
            }
            alt="Collaboration"
          />
          <div>
            <div class="info-right-container">
              <div class="info-card card-purple">
                <div class="icon-box">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/Images/ChooseCluster/stack-icon.png"
                    }
                    alt="Assessment icon"
                  />
                </div>
                <p>
                  The assignment of the cluster is based on the role you perform
                  in your project or your primary skill identified through the
                  mandatory MyCompetency Assessment completed during the
                  Pre-Onboarding Program.
                </p>
              </div>

              <div class="info-card card-grey">
                <div class="icon-box">
                  <img
                    src={
                      process.env.PUBLIC_URL +
                      "/Images/ChooseCluster/chart-icon.png"
                    }
                    alt="Growth icon"
                  />
                </div>
                <p>
                  This ensures every learner is aligned to a cluster that best
                  supports current project needs and future capability growth.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/*  <div className="choose-cluster-purple-card"></div>

      <div className="choose-cluster-grey-card"></div> */}

      {/* <div className="choose-cluster-purple-icon">
        <img
          src={process.env.PUBLIC_URL + "/Images/ChooseCluster/stack-icon.png"}
          alt=""
        />
      </div>

      <div className="choose-cluster-grey-icon">
        <img
          src={process.env.PUBLIC_URL + "/Images/ChooseCluster/chart-icon.png"}
          alt=""
        />
      </div> */}

      {/* <p className="choose-cluster-purple-text">
        The assignment of the cluster based on the role you perform in your
        project or your primary skill identified through the mandatory{" "}
        <strong>MyCompetency Assessment</strong> completed during the{" "}
        <strong>Pre‑Onboarding Program</strong>.
      </p>

      <p className="choose-cluster-grey-text">
        This ensures every learner is aligned to a cluster that best supports{" "}
        <strong>current project needs</strong> and{" "}
        <strong>future capability growth</strong>.
      </p> */}
    </div>
  );
};

export default ChooseCluster;
